module.exports = __webpack_public_path__ + "static/media/success.525e000e.svg";